import Main from "@/views/Main.vue";
const dataCheckRoutes = [
  {
    path: "/datacheck",
    icon: "android-menu",
    name: "datacheck",
    title: "履约数据考核",
    component: Main,
    children: [
      {
        path: "shopnode",
        title: "买手店节点",
        name: "shopnode",
        component: resolve => {
          require(["@/views/dataCheck/shopNode/index.vue"], resolve);
        }
      },
      {
        path: "areadetail",
        title: "大区详情",
        name: "areadetail",
        component: resolve => {
          require(["@/views/dataCheck/shopNode/areaDetail.vue"], resolve);
        }
      },
      {
        path: "shopdetail",
        title: "单店详情",
        name: "shopdetail",
        component: resolve => {
          require(["@/views/dataCheck/shopNode/shopDetail.vue"], resolve);
        }
      },
      {
        path: "gradeconfig",
        title: "评分配置",
        name: "gradeconfig",
        component: resolve => {
          require(["@/views/dataCheck/gradeConfig/index.vue"], resolve);
        }
      },
      {
        path: "performanceCheck",
        title: "履约审核",
        name: "performanceCheck",
        component: resolve => {
          require(["@/views/dataCheck/shopNode/performanceCheck.vue"], resolve);
        }
      },
    ]
  }
]

export default dataCheckRoutes
